/* eslint-disable camelcase */
import ScorecardSelector from '@v4/utils/selectors/ScorecardSelector'
import { createSelector } from 'reselect'
import BaseSelector, { hookFromSelector, withStaticSelector } from './BaseSelector'

const DEFAULT_COlORS = Object.freeze([
	'#d0021b',
	'#f5a623',
	'#f8e71c',
	'#8b572a',
	'#7ed321',
	'#417505',
	'#bd10e0',
	'#9013fe',
	'#4a90e2',
	'#50e3c2',
	'#b8e986',
	'#000000',
	'#4a4a4a',
	'#9b9b9b',
	'#ffffff',
])
class ColorsSelector extends BaseSelector {
	static get DEFAULT_COlORS() {
		return DEFAULT_COlORS
	}

	static fromStoreState(store) {
		return new this(store.colors)
	}

	@hookFromSelector('useRecent')
	@withStaticSelector
	selectRecent() {
		return this.state.recent
	}
}

/**
 * @class ColorsSelector
 * @property {function(storeState: Object): Array<string>} selectPreset
 * @property {function(): Array<string>} usePreset
 */
ColorsSelector.addSelector(
	'selectPreset',
	createSelector([ColorsSelector.selectRecent, ScorecardSelector.selectSettings], (recentColors, settings) =>
		settings
			? _.uniq([
					settings.brand_colour_primary,
					settings.brand_colour_secondary,
					...recentColors,
					...ColorsSelector.DEFAULT_COlORS,
			  ]).slice(0, 16)
			: recentColors,
	),
)

export default ColorsSelector
